import geetest from './geetest'
import sms from './sms/index'
import dict from './dict'
import date from './date'
import image from './image'
import member from './member'

export default {
  geetest,
  sms,
  dict,
  date,
  image,
  member
}



// WEBPACK FOOTER //
// ./src/api/pub/index.js